import { useState, useEffect, useCallback, useRef } from 'react';
import { getEmailRecipientRules } from '../api';

export default function useEmailRecipientRules({ companyId }) {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const fetchIdRef = useRef(0);

    const fetch = useCallback(async () => {
        if (!companyId) { setData([]); return; }
        const fetchId = ++fetchIdRef.current;
        setLoading(true);
        setError(null);
        try {
            const res = await getEmailRecipientRules(companyId);
            if (fetchId === fetchIdRef.current) {
                setData(res.data || []);
            }
        } catch (err) {
            if (fetchId === fetchIdRef.current) {
                setError(err.message || 'Failed to load email recipient rules');
            }
        } finally {
            if (fetchId === fetchIdRef.current) {
                setLoading(false);
            }
        }
    }, [companyId]);

    useEffect(() => { fetch(); }, [fetch]);

    return { data, loading, error, refetch: fetch };
}
